








import { Vue, Component, Prop } from 'vue-property-decorator'
import VueMarkdown from 'vue-markdown'

@Component({
  components: {
    VueMarkdown
  }
})
export default class RichText extends Vue {
  @Prop({ default: '' }) body!: string
}
